// src/features/statistics/components/LocationList.tsx

import type { LocationItem } from '../types/audience';

type Props = {
  title: string;
  items: LocationItem[];
};

export function LocationList({ title, items }: Props): JSX.Element {
  if (items.length === 0) {
    return (
      <div>
        <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2">{title}</div>
        <div className="text-sm text-muted-foreground">Нет данных</div>
      </div>
    );
  }

  return (
    <div>
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-3">{title}</div>
      <div className="flex flex-col gap-2">
        {items.map(item => (
          <div key={item.name}>
            <div className="flex justify-between text-xs mb-0.5">
              <span className="text-foreground truncate max-w-[70%]">{item.name}</span>
              <span className="text-primary font-medium tabular-nums">{item.value}%</span>
            </div>
            <div className="h-1 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary rounded-full transition-all"
                style={{ width: `${item.value}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
